"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import OrganizationForm from './OrganizationForm';

import { OrganizationActions, AlertActions } from '../../../actions';

class Organization extends Component{
  constructor() {
    super();

    this.state = {
      canSubmit: false
    };

    this._onFormValid = this._onFormValid.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };

  render() {
    const { canSubmit } = this.state;
    const { open } = this.props;

    return(
      <Modal show={ open } onHide={Organization._handleCloseOrganizationPopup}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrganizationForm ref={ form => this.organizationForm = form } isValid={ this._onFormValid } actionButtons={ false }/>
          <div>
          <Button bsStyle="success" disabled={ !canSubmit } onClick={this._handleSubmit} >Submit</Button>
          <Button className="m-l-5p" type="submit" bsStyle="default" onClick={ Organization._handleCloseOrganizationPopup }>Cancel</Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  };

  static _handleCloseOrganizationPopup() {
    OrganizationActions.hideOrganizationPopup();
  };

  _onFormValid(isValid) {
    this.setState({ canSubmit: isValid });
  };

  _handleSubmit(e) {
    e.preventDefault();
    const payload = this.organizationForm.getModel();
    const file = payload.file;
    OrganizationActions
      .create(payload, file, error => {
        if(error) return AlertActions.error(error);

        OrganizationActions.hideOrganizationPopup();
        AlertActions.success({ message: 'Organization Created Successfully.' });
      });
  }
}

export default Organization;
